
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ypo-awarded-supplier",
      function () {
        return require("private-next-pages/ypo-awarded-supplier/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ypo-awarded-supplier"])
      });
    }
  